let audioContext: AudioContext | null = null;

function context(): AudioContext | null {
  if (typeof window === "undefined") return null;
  audioContext ??= new AudioContext();
  if (audioContext.state === "suspended") void audioContext.resume();
  return audioContext;
}

export function sound(kind: "card" | "chin" | "alert" | "error" | "ready", enabled: boolean): void {
  if (!enabled) return;
  const audio = context();
  if (!audio) return;

  const oscillator = audio.createOscillator();
  const gain = audio.createGain();
  const start = audio.currentTime;
  const config = {
    card: { from: 260, to: 180, duration: 0.045, volume: 0.035 },
    chin: { from: 440, to: 760, duration: 0.13, volume: 0.055 },
    alert: { from: 520, to: 880, duration: 0.09, volume: 0.05 },
    error: { from: 150, to: 105, duration: 0.1, volume: 0.04 },
    ready: { from: 360, to: 520, duration: 0.08, volume: 0.04 },
  }[kind];

  oscillator.type = kind === "chin" ? "triangle" : "sine";
  oscillator.frequency.setValueAtTime(config.from, start);
  oscillator.frequency.exponentialRampToValueAtTime(config.to, start + config.duration);
  gain.gain.setValueAtTime(config.volume, start);
  gain.gain.exponentialRampToValueAtTime(0.001, start + config.duration);
  oscillator.connect(gain).connect(audio.destination);
  oscillator.start(start);
  oscillator.stop(start + config.duration);
}

export function haptic(kind: "card" | "chin" | "error", enabled: boolean): void {
  if (!enabled || typeof navigator === "undefined" || !("vibrate" in navigator)) return;
  const pattern = kind === "chin" ? [22, 28, 42] : kind === "error" ? [35, 30, 35] : 12;
  navigator.vibrate(pattern);
}
